const appEnv = process.env.APP_ENV;

export const CookieNames = Object.freeze({
  ACCESS_TOKEN: `bambee-${appEnv}-access-token`,
  REFRESH_TOKEN: `bambee-${appEnv}-refresh-token`,
  MASQUERADE: `bambee-${appEnv}-masquerade`,
  UPGRADE_DISMISSED: `bambee-${appEnv}-upgrade-dismissed`,
  // Hexagon handoff flags for the $1 Premium People trial (BIO-1350). Set on the shared parent
  // domain (same as the access-token cookie) so Hexagon, on a *.bambee.com subdomain, can read them
  // alongside the existing auth token. Two separate cookies by design: one marks the plan, one the
  // trial state, so Hexagon can key UI/entitlement on each independently.
  PP_PLAN_CUSTOMER: `bambee-${appEnv}-pp-plan-customer`,
  PP_TRIAL: `bambee-${appEnv}-pp-trial`,
  // The A/B experiment arm for the $1 Premium People trial (BIO-1350). The URL ?arm= wins when
  // present; this cookie is the fallback, written on landing on the shared parent domain so the arm
  // survives the URL changing out from under the funnel (back button, an auth redirect that strips
  // ?arm=) and so Hexagon can attribute it too.
  TRIAL_ARM: `bambee-${appEnv}-pp-trial-arm`,
});

export default CookieNames;
